import {
  LayoutObjectsApi,
  UpdateLayoutObjectLayoutPositionRequest,
  UpdateLayoutObjectRequest,
} from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'
import { CreateLayoutObjectRequest } from '@yard/pages/YardSetup/helpers/layout-object.mapper'

class LayoutObjectService {
  private readonly httpClient = createApiClient(LayoutObjectsApi)

  async getLayoutObjects() {
    const { data } = await this.httpClient.getLayoutObjects()

    return data.layoutObjects
  }

  async updateLayoutPosition(layoutPosition: UpdateLayoutObjectLayoutPositionRequest) {
    await this.httpClient.updateLayoutObjectLayoutPosition(layoutPosition)
  }

  async create(yardBlock: CreateLayoutObjectRequest) {
    const { data } = await this.httpClient.createLayoutObject(
      yardBlock.name,
      yardBlock.width,
      yardBlock.height,
      yardBlock.type,
      yardBlock.positionX,
      yardBlock.positionY,
      yardBlock.positionRotation,
      yardBlock.image,
      yardBlock.description,
      yardBlock.color,
      yardBlock.opacity,
      yardBlock.code,
      yardBlock.direction,
      yardBlock.active,
    )
    return data.id
  }

  async update(yardBlock: UpdateLayoutObjectRequest) {
    const { data } = await this.httpClient.updateLayoutObject(yardBlock)
    return data
  }

  async delete(id: string) {
    await this.httpClient.deleteLayoutObject({ id })
  }

  async getLayoutObjectImage(path: string) {
    const { data } = await this.httpClient.getLayoutObjectImage(path, { responseType: 'blob' })
    return data as unknown as Blob
  }
}

export const layoutObjectService = new LayoutObjectService()
